import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

//Components
import Button from "../Components/Other Components/button";

//CSS
import "../Components/Other Components/crashCover.css";

import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();
  return (
    <motion.div
      className="crash-cover"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <h1 className="crash-cover-header-large">404</h1>
      <h2 className="crash-cover-header">{t("Page Not Found")}</h2>
      <p className="crash-cover-text">
        {t(
          "Sorry, the page you are looking for doesn't exist or has been moved."
        )}
      </p>
      <div className="btn-container w-100">
        <Button onClick={() => navigate("/login")}>{t("Go back")}</Button>
      </div>
    </motion.div>
  );
};

export default NotFoundPage;
